<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card border border-radius-12">

          <div class="card-body table mb-0">
                                    <div class="toolbar-container px-3">
              <div class="toolbar-row d-flex align-items-center justify-content-between mb-2">
                <PageHeader :title="title" :items="items" class="poppins fw-normal ps-0 text-nowrap" />
                <div class="d-flex gap-2 flex-wrap p-0 buttons-container">
                  <CustomButton 
                    :buttonText="downloadReportProcessing ? 'Please wait...' : 'Download Report'"
                    :loading = "downloadReportProcessing"
                    class="p-0"
                    @click="downloadReport" 
                  />
                </div>
              </div>

              <div class="toolbar-row d-flex gap-2 align-items-center">
                <searchInput @getSearched="handleSearch" class="p-0" />
                <pageSize @getPageSize="handlePageSize" class="page-size-btn p-0" />    
              </div>
            </div>
            <!-- <div class="row justify-content-between">
              <div class="col-xl-12 col-12">
                <div class="d-flex align-items-sm-center align-items-start gap-lg-5 gap-2 flex-column flex-sm-row">
                  <PageHeader :title="title" :items="items" class="poppins fw-normal ps-3 text-nowrap" />
                  <searchInput @getSearched="handleSearch" class="w-50" />
                  <pageSize @getPageSize="handlePageSize" />

                  <div class="d-flex justify-content-end gap-2 mt-2 mt-xl-0 ms-auto"> -->
                    <!-- <div class="add_new border-orange rounded-pill p1">
                      <button
                        @click="downloadReport"
                        class="btn btn-primary border-0 px-4 fw-bold text-white waves-effect waves-light w-md primary-button rounded-pill"
                        :disabled="downloadReportProcessing"
                      >
                        {{ downloadReportProcessing ? 'Please wait...' : 'Download Report' }}
                      </button>
                    </div> -->
                    <!-- <CustomButton
                        :buttonText="downloadReportProcessing ? 'Please wait...' : 'Download Report'" 
                        :disabled="downloadReportProcessing"
                        @click="downloadReport" 
                    />
                  </div>
                </div>

              </div>
            </div> -->
            <GeneralTable :isProcessing="processing" :items="items" :fields="fields" @no-records-found="onRecordsFount" :showEyeButton="true" :showActionButton="false"
              @showItem="showPlan"/>

            <b-modal ref="plan-modal" hide-footer isModalVisible title="Subscription Plan Details" size="lg">
              <template v-slot:default>
                <div v-if="planLoading">
                  <APILoader :loading="planLoading" class="align-middle text-center" />
                </div>

                <div v-else>
                  <div v-if="selectedPlan" class="invoice-info">
                    <div class="invoice-column">
                      <p><strong>ID:</strong> {{ selectedPlan.id }}</p>
                      <p><strong>Name:</strong> {{ selectedPlan.name }}</p>
                      <p><strong>Amount:</strong> {{ formatAmount(selectedPlan.amount) }}</p>
                      <p><strong>Interval:</strong> {{ selectedPlan.interval || 'N/A' }}</p>
                    </div>
                    <div class="invoice-column">
                      <p><strong>Meta:</strong></p>
                      <pre v-if="selectedPlan.meta" class="mb-2" style="white-space: pre-wrap; word-break: break-word;">
{{ prettyMeta(selectedPlan.meta) }}
                      </pre>
                      <p v-else>N/A</p>
                      <p><strong>Created At:</strong> {{ formatDate(selectedPlan.created_at) }}</p>
                      <p><strong>Updated At:</strong> {{ formatDate(selectedPlan.updated_at) }}</p>
                    </div>
                  </div>

                  <div v-else class="text-center">
                    <p>No plan data available.</p>
                  </div>
                </div>
              </template>
            </b-modal>

            <Pagination @paginator="getPlans" :pagination="paginatelinks" :showing="paginate"
              @page-changed="handlePageChange" />
            <!-- end table-responsive -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../../layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import $ from "jquery";
import GeneralTable from "../../../../components/MagicTable/GeneralTable.vue";
import Pagination from "../../../../components/general/pagination.vue";
import searchInput from "../../../../components/general/searchInput.vue";
import pageSize from "../../../../components/general/pageSize.vue";
import CustomButton from "../../../../components/CustomButton.vue";
export default {
  page: {
    title: "Subscription Plans",
    meta: [
      {
        name: "subscription-plans",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    GeneralTable,
    Pagination,
    searchInput,
    pageSize,
    CustomButton,
  },

  data() {
    return {
      currentPageNumber: null,
      fields: [
        { key: "id", label: "ID", tdClass: "align-middle" },
        { key: "name", label: "Name", tdClass: "align-middle" },
        { key: "amount", label: "Amount", tdClass: "align-middle" },
        { key: "interval", label: "Interval", tdClass: "align-middle" },
        { key: "created_at", label: "Created At", tdClass: "align-middle" },
        { key: "action", tdClass: "" },
      ],
      sort_by: '',
      selectedRows: [],
      items: [],
      currentPage: 1,
      itemsPerPage: 10,
      multipuleIds: [],
      selectAll: false,
      loading: true,
      users: null,
      paginatelinks: [],
      title: "Subscription Plans",
      processing: false,
      paginate: {},
      pageSize: 10,
      selectedPlan: null,
      planLoading: false,
      downloadReportProcessing: false,
    };
  },

  computed: {
    itemsBreadcrumb() {
      return [
        { text: "Omaha" },
        { text: "Subscription Plans", active: true },
      ];
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.items.slice(start, start + this.itemsPerPage);
    },
  },

  mounted() {
    let url = null;
    if (this.$route.query.currentPage) {
      url = `subscription-plans?page=${this.$route.query.currentPage}`;
    }
    this.getPlans({ url, pageSize: this.pageSize });
    this.processing = true;
  },
  methods: {
    formatAmount(amount) {
      if (amount === null || amount === undefined) {
        return "$0.00";
      }
      const num = Number(amount);
      if (isNaN(num)) {
        return String(amount);
      }
      return `$${num.toFixed(2)}`;
    },

    formatDate(isoDate) {
      if (!isoDate) return "N/A";

      const date = new Date(isoDate);

      if (isNaN(date.getTime())) {
        return isoDate;
      }

      let day = date.getDate();
      let month = date.toLocaleString("default", { month: "long" });
      let year = date.getFullYear();

      let getDaySuffix = (day) => {
        if (day > 3 && day < 21) return "th";
        switch (day % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      };

      return `${day}${getDaySuffix(day)} ${month} ${year}`;
    },

    prettyMeta(meta) {
      try {
        if (typeof meta === "string") {
          const parsed = JSON.parse(meta);
          return JSON.stringify(parsed, null, 2);
        }
        return JSON.stringify(meta, null, 2);
      } catch (e) {
        return String(meta);
      }
    },

    showPlan(planId) {
      this.planLoading = true;
      this.selectedPlan = null;

      this.$axios
        .get(`subscription-plans/${planId}`)
        .then((response) => {
          const plan = response?.data?.data || null;
          this.selectedPlan = plan;
          this.planLoading = false;
          this.openPlanModal();
        })
        .catch((error) => {
          console.error("Error fetching plan:", error);
          this.planLoading = false;
          if (typeof this.triggerSwal === "function") {
            this.triggerSwal("Failed to fetch plan details.", "error");
          } else {
            alert("Failed to fetch plan details.");
          }
        });
    },

    openPlanModal() {
      this.$refs["plan-modal"].show();
    },

    hideModal() {
      return this.$refs["plan-modal"].hide();
    },

    downloadReport() {
      if (!this.items || this.items.length === 0) {
        if (typeof this.triggerSwal === "function") {
          this.triggerSwal("No data available to download.", "warning");
        } else {
          alert("No data available to download.");
        }
        return;
      }

      this.downloadReportProcessing = true;

      const headers = [
        "ID",
        "Name",
        "Amount",
        "Interval",
        "Created At",
      ];

      const rows = this.items.map((plan) => [
        plan.id,
        plan.name,
        plan.amount,
        plan.interval || "",
        plan.created_at,
      ]);

      let csvContent = "";
      csvContent += headers.join(",") + "\n";

      rows.forEach((row) => {
        csvContent +=
          row
            .map((value) =>
              `"${String(value ?? "")
                .replace(/"/g, '""')
                .replace(/\n/g, " ")}"`
            )
            .join(",") + "\n";
      });

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `subscription-plans-${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      this.downloadReportProcessing = false;
    },

    // TABLE CALLBACKS

    onRecordsFount() {
      this.getPlans({ pageSize: this.pageSize, searchItem: null, sortBy: null });
      this.currentPage = 1;
    },

    handlePageChange(pageNumber) {
      if (pageNumber <= 0) {
        this.triggerSwal?.("Page not found. Please enter a valid page number.", "error");
        return;
      }

      const lastPageUrl = this.paginate?.last_page;
      let lastPage = 1;
      if (lastPageUrl) {
        const match = lastPageUrl.match(/page=(\d+)/);
        if (match && match[1]) {
          lastPage = parseInt(match[1], 10);
        }
      }

      if (pageNumber > lastPage) {
        this.triggerSwal?.("Page not found. Please enter a valid page number.", "error");
        return;
      }
      const baseUrl = "subscription-plans";
      const pageUrl = `${baseUrl}?page=${pageNumber}`;
      this.getPlans({ url: pageUrl, pageSize: this.pageSize });
    },
    handleSearch(searchItem) {
      this.getPlans({ searchItem, pageSize: this.pageSize });
    },

    filtration() {
      this.getPlans({ sortBy: this.sort_by, pageSize: this.pageSize });
    },

    updateCurrentPage(newPage) {
      this.currentPage = newPage;
    },

    handlePageSize(newPageSize) {
      this.pageSize = newPageSize || 10;
      this.getPlans({ pageSize: this.pageSize });
    },
    randerData(response) {
      const plansData = response?.data?.data;
      this.currentPageNumber = plansData.current_page;

      this.paginate = {
        first_page: plansData.first_page_url,
        last_page: plansData.last_page_url,
        links: plansData.links,
        from: plansData.from,
        to: plansData.to,
        total: plansData.total,
      };
      this.paginatelinks = this.paginate.links.map((item) => ({
        url: item.url,
        label: item.label,
        active: item.active,
      }));

      let plans = Array.isArray(plansData?.data) && plansData?.data.length > 0
        ? plansData?.data
        : [];

      this.items = plans.map((plan) => ({
        id: plan.id,
        name: plan.name,
        amount: this.formatAmount(plan.amount),
        interval: plan.interval || "N/A",
        created_at: this.formatDate(plan.created_at),
        meta: plan.meta || null,
      }));

      this.processing = false;
    },

    getPlans({ url = null, searchItem = null, pageSize = this.pageSize } = {}) {
      this.processing = true;
      let endPoint = "subscription-plans";
      endPoint = url ? url : endPoint;
      this.$axios
        .get(endPoint, {
          params: {
            search: searchItem,
            page_size: pageSize,
          },
        })
        .then((response) => {
          console.log("i have response",response);
          setTimeout(() => this.randerData(response), 1500);
        })
        .catch((error) => {
          console.log(error.response);
          this.processing = false;
        });
    },
  },
};
</script>

<style scoped>
.invoice-info {
  display: grid;
  grid-template-columns: 1fr 1fr; 
  gap: 20px; 
}

.invoice-column {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .invoice-info {
    grid-template-columns: 1fr; 
  }
}
.toolbar-container {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.toolbar-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}

@media (max-width : 576px){
  .card-body{
    padding : 0.25rem !important;
  }
  .toolbar-row {
    justify-content: flex-start;
  }

  .toolbar-row:first-child {
    flex-direction: column;
    align-items: flex-start;
  }
  .buttons-container{
    width : 100%;
  }
}
@media (max-width: 768){
  .table > :not(caption) > * > *
  {
    padding: 0.25rem !important;
  }
}
</style>